module.exports = __webpack_public_path__ + "MindShapesLogo.png";